<template>
    <v-app>
      <v-container>
        <form class="rform">
        <div	class="form-group	row">
              <h3>Cambio Interdepartamental</h3>
        </div>
        <div	class="form-group	row col-md-6">
              <v-select
                v-model="select"
                :items="items"
                label="Deudor"
                data-vv-name="select"
                required></v-select>
        </div>
        <div	class="form-group	row col-md-6">
              <v-select
                v-model="select"
                :items="deptos"
                label="Departamento"
                data-vv-name="select"
                required></v-select>
        </div>
        <div	class="form-group	row col-md-6">
                <v-textarea
                  counter
                  label="Descripción"
                  :rules="rules"
                  :value="value"
                ></v-textarea>
       </div>      
        
        <div	class="form-group	row col-md-6 align-center">    
          
                <v-btn
                color="success"
                class="mr-4"
                @click="validate">
                Actualizar
              </v-btn>
          
          </div>
        </form>
      </v-container>
    </v-app>
</template>



<script>
// @ is an alias to /src
import axios from "axios";
import router from '../router/index.js'
export default {
  name: 'comprobacion',
  data:() => ({
    items: [
        'SERGIO	DAVILA	NAJERA',
        'BENJAMIN	HERNANDEZ	MARTINEZ',
        'CARMELO TADEO	ACEVEDO	ORTIZ',
        'MIGUEL	PEREZ	HURTADO',
        'JOSE ARMANDO	PALACIOS	RODRIGUEZ',
        'JULIO CESAR	ALVAREZ	HERNANDEZ',
        'CELESTINO	COCOLETZI	ESCAMILLA',
        'MIGUEL ANGEL	SANCHEZ	RUBIO',
        'MAURO EDGAR	GARCIA	MUNIZ',
        'ARACELI JAZMIN	MIGUEL	BUTANDA',
        'KARLA ELIZABETH	RESENDIZ	MARTINEZ',
        'MILDRED	ALVAREZ	MAYA',
        'SHARON MARLEN	SERRANO	BOLANOS',
        'CHARLES JACQUES HENRI 	LAMS',
        'CHARLES BAPTISTE BERNARD	NEDELEC',
        'CARMEN SUSANA	LOPEZ	RAMIREZ',
        'ROCIO	MANCILLA	TAPIA',
        'JESUS ALFREDO	MALDONADO	CASTRO',
        'BRENDA BERENICE	MARTINEZ	VIGIL',
        'OMAR CRISTIAN	RAMIREZ	TORRES',
        'MARIA CRUZ	GARCIA	HERNANDEZ',
        'JOSE ANTONIO	ESPINOSA	GUIMBARDA',
        'ALMA	SALDAÑA	ESTRADA',
        'ANAHI YOCABETH	DOMINGUEZ	SERRANO',
        'JAQUELINE ODET DOLORES	RAMOS 	CASTRO',
        'FERNANDO	GARCIA	ZAMORA',
        'THALIA YVETTE	AMABILIS	SALAMANCA',
        'MARIO ALBERTO	CABRERA	MARTINEZ',
        'IVONNE	JIMENEZ	ESTRADA',
        'FERNANDO	NAVARRO	CASTILLO',
        'YESENIA	PERALTA 	BENITEZ',
        'JOSE MANUEL	MEJIA 	GUZMAN',
        'ANA TERESA	GARCIA	MANCIO',
        'YANET	VIVAS	MARTINEZ',
        'INGRID PAOLA	CABRERA	BOLBRUGGE',
        'JESUS	VALERIANO	CESPEDES',
        'YOSAHANDI ALEJANDRA	MORENO	GUTIERREZ',
        'IRAIS ELIZABETH	TORRENTES	JIMENEZ',
        'ANDREA IVONNE	MORÁN	LARA',
        'EVELYN	GLORIA 	ARÉVALO',
        'MARCO ANTONIO	SPEZZIA 	MACEDA',
        'CHRISTIAN GERARDO	PEÑA	ARRIETA',
        'FRANCISCO JAVIER	RODRÍGUEZ 	ESPINOZA',
        'HELGA 	MAGNOT	GONZÁLEZ',
        'INGRID ARIADNA	ORTIZ	RUIZ',
        'PIERRE JACQUES MARCEL	REBOUR',
        'FRIDA	AYALA	ORTIZ',
        'DENISSE FARIDE	GUERRERO	GARCÍA',
        'LAURA ALEJANDRA	CHAVEZ	ZARAGOZA',
        'MARIA FERNANDA	HERNANDEZ	MENDOZA',
        'MANUEL	TORRES 	BARRAZA',
        'JESUS ELADIO	ESPINO	RANGEL',
        'FRANCISCO AGUSTIN 	DOMÍNGUEZ 	CROCHE',
        'ANGEL GUILLERMO	ORTÍZ	CORONA',
        'MIGUEL DE JESÚS 	MENDOZA 	JUAN',
        'PAULINE CHARLOTTE ANE	LAMY	ONTROUP',
        'GEORGE MATTHIAS	PETIT DE LA RHODIERE',
        'ALMA FABIOLA	LAMADRID	PIERRES',
        'DANIEL 	LÓPEZ	VALDEZ',
        'NOHEMI AZAREL 	HERNÁNDEZ	VALENCIA',
        'CLAUDIA MICHEL 	SOTO 	BARRIOS',
        'FERNANDA	HERNÁNDEZ	JERÓNIMO',
        'PAOLA BETIANA	SALGADO	DÁVILA',
        'CHLOE LAURENCE MARLENE	SUCCO',
        'MARIANA VERONICA	MALACARA	LUNA',
        'LIA	URIBE	ALCANTAR',
        'KENYA MAXELL	CAMACHO	RESENDIZ',
        'CECILIA 	GARCÍA	TELLO',
        'CESAR ADMIN	MARTÍNEZ	PEÑA',
        'ALMA KARINA	REYES	PADILLA',
        'CRISTIAN 	BRAVO	GONZÁLEZ',
        'RODOLFO ARTURO	RODRÍGUEZ 	CAMPOS',
        'SEBASTIAN	CARREON	GONZÁLEZ',
        'VERÓNICA	IBAÑEZ	CASTILLO',
        'HUMBERTO	PEREZ	MORAN',
        'LILIANA AIDE	ESCAMILLA	MONTIEL',
        'MARÍA DANIELA	GAMIÑO	ROMERO',
        'SANDRA NAYELI	LUISES	ALONSO',
        'KATHLEEN MARIA MARTHA MICHEL	SURMONT',
        'JORGE ALBERTO 	MARTÍNEZ	VARELA',
        'ADRIANA JIMENA	GUTIÉRREZ	ALEGRÍA',
        'VALERIA MARIANA	GONZÁLEZ	CABRERA',
        'NOËLLA DOMINIQUE ISABELLE	AMIAND',
        'SOFÍA  AMALINALLI	DOMINGUEZ 	GONZALEZ',
        'MARIA DEL ROSARIO	DE LA CRUZ	APOLINAR',
        'NORA IRENE	FLORES	QUIROZ',
        'NOEL	ZARZA 	CASTRO',
        'INGRID ROXANA	LEMUS	LEYVA'],
    deptos: ['4PL',
        'AEREO',
        'AEROSPACE',
        'ALMACEN',
        'CONTABILIDAD',
        'CONTROLLING',
        'CYC',
        'FINANZAS',
        'IT',
        'MANAGEMENT',
        'MARITIMO',
        'OIL & GAS',
        'OPERACIONES',
        'OPERACIONES SLP',
        'OPERACIONES GDL',
        'PRICING',
        'REGIONAL',
        'RH ',
        'TERRESTRE',
        'VENTAS']
  }),
  mounted() {
      //Config for axios
      axios.defaults.headers.common['access-token'] = this.$store.state.token;

      axios.interceptors.response.use(function (response){
          //console.log(response.data.message);
          if (response.data.message == 'Token inválida') {
              router.push({name: 'login', params: {errorToken: 'true'}});
          }else{
              return response;
          }
      });
      //End config for axios
  }
}
</script>
<style scoped>
#rowp{
  border: 1px #000 solid !important;
}
.rform{
  padding:120px;  
}
</style>
